import {Component, EventEmitter, Input, model, OnInit, Output} from '@angular/core';
import {ButtonModule} from 'primeng/button';
import {SelectButtonModule} from 'primeng/selectbutton';
import {FormsModule} from '@angular/forms';
import {SliderModule} from 'primeng/slider';
import { InputNumberModule } from 'primeng/inputnumber';
import {ColorPickerModule} from 'primeng/colorpicker';
import {ColorPickerComponent} from './color-picker/color-picker.component';
import {TranslationPipe} from '../../../../pipes/translation.pipe';

@Component({
  selector: 'app-toolbar',
  imports: [ButtonModule, SelectButtonModule, FormsModule, SliderModule, InputNumberModule, ColorPickerModule, ColorPickerComponent, TranslationPipe],
  templateUrl: './toolbar.component.html',
  styleUrl: './toolbar.component.scss'
})
export class ToolbarComponent implements OnInit {
  @Output() colorChange = new EventEmitter<string>();
  @Output() drawingModeChange = new EventEmitter<'free'|'circle'>();
  @Output() lineWidthChange = new EventEmitter<number>();
  @Output() circleRadiusChange = new EventEmitter<number>();
  @Output() triggerRedo = new EventEmitter<void>();
  @Output() triggerUndo = new EventEmitter<void>();
  currentDrawingMode !:'free'|'circle';
  drawingModeOptions!: any[];
  lineWidth!: number;
  circleRadius!: number;
  @Output() onSave=new EventEmitter();

  historyIndex = model<number>(0);
  canvasHistoryLength=model<number>(0);

  constructor() {
    this.drawingModeOptions=[{icon:"pi pi-pencil",value:'free'},{icon:"pi pi-circle-off",value:'circle'}];
    this.currentDrawingMode='free';
    this.lineWidth = 5;
    this.circleRadius = 50;
  }

  ngOnInit() {
    this.drawingModeOptions=[{icon:"pi pi-pencil",value:'free'},{icon:"pi pi-circle-off",value:'circle'}];
    this.currentDrawingMode='free';
    this.changeDrawingMode('free');
    this.lineWidth = 5;
    this.changeLineWidth(5);
    this.circleRadius = 50;
    this.changeCircleRadius(50);
  }

  changeColor(color: string|object) {
    if (typeof color == "string")
    {
      this.colorChange.emit(color);
    }
    else if (typeof color == "object"){
      this.colorChange.emit(color.toString());
    }
  }

  changeDrawingMode(mode:'free' | 'circle') {
    this.drawingModeChange.emit(mode);
  }

  changeLineWidth(lineWidth: number) {
    this.lineWidthChange.emit(lineWidth);
  }

  changeCircleRadius(circleRadius: number) {
    this.circleRadiusChange.emit(circleRadius);
  }

  protected save() {
    this.onSave.emit();
  }

  protected stepLineWidth(number: number) {
    this.lineWidth += number;
    this.lineWidthChange.emit(this.lineWidth);
  }

  protected stepCircleRadius(number: number) {
    this.circleRadius += number;
    this.circleRadiusChange.emit(this.circleRadius);
  }
}
